import React from 'react'

export const Services = () => {
  return (
    <div>
      {/* <!--banner start--> */}

<div class="services-banner">
  <div class="s-s-banner">
    <div class="sr-slider owl-carousel owl-theme">
        <div class="item">
            <img src="./images/1711027941_computer-3174729_1280.webp" alt="images not found" />
            <div class="cover">
                <div class="container">
                    <div class="header-content">
                        <div class="line"></div>
                        
                        <p>Transforming Your Business into Reality</p>
                        
                        <h1>Digital Marketing Services Company</h1>
                        
                    </div>
                </div>
             </div>
        </div>      
        <div class="item">
            <img src="./images/1711028227_streetart-519724_1280.webp" alt="images not found" />
            <div class="cover">
                <div class="container">
                    <div class="header-content">
                        <div class="line"></div>
                        
                        <p>Graphics Designing and Animation Services in Kolkata</p>
                        
                        <h1>Professional Graphic Design</h1>
                        
                    </div>
                </div>
             </div>
        </div>     
        <div class="item">
            <img src="./images/1711028426_startup-594090_1280.webp" alt="images not found" />
            <div class="cover">
                <div class="container">
                    <div class="header-content">
                        <div class="line"></div>
                        
                        <p>High-Quality & Unique Content Writing Services at Affordable Prices</p>
                        
                        <h1>Content Writing Services kolkata</h1>
                        
                    </div>
                </div>
             </div>
        </div>            
    </div>
</div>
</div>

{/* <!--banner end--> */}




{/* <!--middle start--> */}

<main>
  {/* <!--services section 1 start--> */}

  <div class="services-section-1">
    <div class="container">
      <div class="s-s-1-top text-center">

        <b>All Services</b>

        <p>We at Passionate Futurist provide Best Service in India</p>
      </div>

      <div class="s-s-1-wrap">
        <div class="row">
         <div class="col-lg-3 mb-4">
    <div class="s-s-1-w-inner">
        <div class="s-s-1-w-i-image">
            <img src="" alt="" />
        </div>

        <div class="s-s-1-w-i-ctgy">
            <img src="./images/1707484762_bullhorn.webp" alt="" />
        </div>

        <h4>Digital Marketing</h4> 
                
        <p>Best Digital Marketing Services for Transforming Your Business into Reality</p>
                
            <button class="btn s-s-4-r-button btn-warning">Learn More 
                <i class="fa-regular s-s-4-r-b-icon fa-circle-right"></i>
            </button>
    </div>
</div>
<div class="col-lg-3 mb-4">
    <div class="s-s-1-w-inner">
        <div class="s-s-1-w-i-image">
            <img src="" alt="" />
        </div>

        <div class="s-s-1-w-i-ctgy">
            <img src="./images/1707484826_illustration.webp" alt="" />
        </div>

        <h4>Professional Graphic Design</h4> 
                
        <p>Graphics Designing and Animation Services in Kolkata</p>
                
            <button class="btn s-s-4-r-button btn-warning">Learn More 
                <i class="fa-regular s-s-4-r-b-icon fa-circle-right"></i>
            </button>
    </div>
</div>
<div class="col-lg-3 mb-4">
    <div class="s-s-1-w-inner">
        <div class="s-s-1-w-i-image">
            <img src="" alt="" />
        </div>

        <div class="s-s-1-w-i-ctgy">
            <img src="./images/1707484903_sheet.webp" alt="" />
        </div>

        <h4>Content Writing Services</h4> 
                
        <p>High-Quality & Unique Content Writing Services at Affordable Prices</p>
                
            <button class="btn s-s-4-r-button btn-warning">Learn More 
                <i class="fa-regular s-s-4-r-b-icon fa-circle-right"></i>
            </button>
    </div>
</div>
<div class="col-lg-3 mb-4">
    <div class="s-s-1-w-inner">
        <div class="s-s-1-w-i-image">
            <img src="" alt="" />
        </div>

        <div class="s-s-1-w-i-ctgy">
            <img src="./images/1707484945_creative.webp" alt="" />
        </div>

        <h4>Web Design Services</h4> 
                
        <p>Use Passionate Futurist’s Web Design Services for Better Customer Experiences</p>
                
            <button class="btn s-s-4-r-button btn-warning">Learn More 
                <i class="fa-regular s-s-4-r-b-icon fa-circle-right"></i>
            </button>
    </div>
</div>
        </div>
      </div>
    </div>
  </div>

  {/* <!--services section 1 end--> */}

  
  {/* <!--services section 2 start--> */}
  <div class="services-section-2">
    <div class="container">
       <div class="row">
        <div class="col-lg-6 mb-4">
          <div class="s-s-2-left">
            <h4>Why Choose Us?</h4>

            <h2>We are Best!!</h2>
            <p>Best Digital Marketing Services for Transforming Your Business into Reality</p>
            <p>Passionate Futurist has a team of digital marketers. We offer professional seo service, lead generation service, social media optimization, pay per click management, content marketing or writing and email marketing service. Our company provides the&nbsp;<strong>best digital marketing services</strong>. We have gained the reputation for being a&nbsp;<strong>professional SEO services company</strong>&nbsp;and have improved the website rank of many companies.</p>

            <p>Our company has a team of experts for social media optimization services. We can provide you&nbsp;<strong>digital marketing strategy</strong>&nbsp;for your company. Our&nbsp;<strong>digital enterprise strategy</strong>&nbsp;is quite well known. If you are looking for&nbsp;<strong>digital marketing strategies for online success</strong>, you can contact us immediately! We are among the top&nbsp;<strong>digital marketing service providers in India</strong>.</p>
            
            <div class="s-s-2-l-wrap">
              <div class="col-lg-12 mb-4 text-center">
                <div class="slider slider-nav">
                  <div> 
                    <div class="s-s-2-l-w-inner">
                        <div class="col-lg-12 mb-4">
                        <div class="s-s-2-l-w-i-left">
                            <img src="./images/1711030876_1674806557-mimi-thian-vdXMSiX-n6M-unsplash.webp" alt="" />
                        </div>
                        </div>
                        <div class="col-lg-12 mb-4">
                        <div class="s-s-2-l-w-i-right">
                            <h4>Passionate Futurist’s team</h4>
    
                            <p>Passionate Futurist’s team members’ speciality is to prepare informative websites</p>
                        </div>
                        </div>
                    </div>
                  </div>
                  <div> 
                    <div class="s-s-2-l-w-inner">
                        <div class="col-lg-12 mb-4">
                        <div class="s-s-2-l-w-i-left">
                            <img src="./images/1711032645_online-2900303_1280.webp" alt="" />
                        </div>
                        </div>
                        <div class="col-lg-12 mb-4">
                        <div class="s-s-2-l-w-i-right">
                            <h4>E-commerce websites</h4>
    
                            <p>E-commerce websites are helping users to interact safely and securely </p>
                        </div>
                        </div>
                    </div>
                  </div>
                  <div> 
                    <div class="s-s-2-l-w-inner">
                        <div class="col-lg-12 mb-4">
                        <div class="s-s-2-l-w-i-left">
                            <img src="./images/1688361363_13399753_Work_7.webp" alt="" />
                        </div>
                        </div>
                        <div class="col-lg-12 mb-4">
                        <div class="s-s-2-l-w-i-right">
                            <h4>Dynamic and informative websites</h4>
    
                            <p>The users get dynamic and informative websites that will help satisfy their users.  </p>
                        </div>
                        </div>
                    </div>
                  </div>
                  <div>
                  </div>
                </div>
              </div>
            </div>
         
            <button class="btn l-t-button btn-warning">Lets talk <i class="fa-brands l-t-b-icon fa-rocketchat"></i></button>
          </div>
        </div>
        <div class="col-lg-6 mb-4">
          <div class="s-s-2-right text-center">
            <div class="col-lg-12">
              <div class="slider slider-single">
                <div>
                  <img src="./images/1711031034_team-spirit-2447163_1280.webp" alt="" srcset="" />
                </div>
                <div>
                  <img src="./images/1688361340_surface-coCGW4SsxX4-unsplash.webp" alt="" srcset="" />
                </div>
                <div>
                  <img src="./images/1688361367_sas.webp" alt="" srcset="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  {/* <!--services section 2 end--> */}

   {/* <!--services section 4 start--> */}

   <div class="services-section-4">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 mb-4">
          <div class="s-s-4-left">
            <div class="row">
              <div class="col-lg-6 mb-4">
                <div data-aos="fade-down" data-aos-duration="1500">
                  <div class="s-s-4-l-image s-s-4-l-i-a">
                    <img src="./images/1711031818_student-849828_1280.webp" alt="" />
                  </div>
                </div>
                
              </div>

              <div class="col-lg-6 mb-4">
                <div data-aos="fade-up" data-aos-duration="1500">
                  <div class="s-s-4-l-image s-s-4-l-i-b">
                    <img src="./images/1711031695_internet-8097838_1280.webp" alt="" />
                  </div>
                </div>
                
              </div>

              <div class="col-lg-6 mb-4">
                <div data-aos="fade-right" data-aos-duration="1500">
                  <div class="s-s-4-l-image s-s-4-l-i-c">
                    <img src="./images/1711029198_digital-marketing-1725340_1280.webp" width="100%" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6">
          <div data-aos="fade-up" data-aos-duration="1500">
            <div class="s-s-4-list">         
              <li><h2>We are Best!!</h2></li>
            </div>
          </div>        
    
            <div class="s-p">
              <div data-aos="fade-left" data-aos-duration="1500">
                <ul id="tabs">
                  <li class="active">Digital Marketing</li>
                  <li>Content Create</li>
                  <li>Development</li>
                </ul>
              </div>
              

              <div data-aos="zoom-in" data-aos-duration="1500">
                <div id="content-tab">
                  <div class="active">
                    <p>Making online friends is so 2008, but 2023 is the time to make your brand with digital marketing</p>
  
                    <button class="btn s-s-4-r-button btn-warning">Learn More <i class="fa-regular s-s-4-r-b-icon fa-circle-right"></i></button>
                  </div>
  
                  <div>
                    <p>Content is the key and engagement is the lock, making everyone safe in your lock and key</p>
  
                    <button class="btn s-s-4-r-button btn-warning">Learn More <i class="fa-regular s-s-4-r-b-icon fa-circle-right"></i></button>
                  </div>
  
                  <div>
                    <p>Developing applications is the base of the digital world. </p>
  
                    <button class="btn s-s-4-r-button btn-warning">Learn More <i class="fa-regular s-s-4-r-b-icon fa-circle-right"></i></button>
                  </div>
                </div>
              </div>              
            </div>
        </div>
      </div>
    </div>
  </div>

  {/* <!--services section 4 end--> */}
  
  
  
  {/* <!--Survey Form add start--> */}

    
    {/* <!--Survey Form add end--> */}



  {/* <!--services section 3 start--> */}
  <div class="services-section-3">
    <div class="container">
      <div class="s-s-3-wrap">
          <div class="owl-carousel services-option owl-theme">  
            <div class="item">
              <div class="s-o-inner" style={{ background: "url('./images/1688361663_sas.webp')", backgroundRepeat: 'no-repeat', backgroundPosition: 'center', backgroundSize: 'cover'}}>
                <div class="container-fluid">
                  <div class="s-o-inner-wrap">
                    <div class="row">
                      <div class="col-lg-9 mb-4">
                        <div class="s-o-i-w-left">
                          <h4>We are Best!!</h4>
  
                          <p>Our only spark is our team spirit. Our work is not only our passion but also the lifeline of our team members. </p>
                        </div>
                      </div>
  
                      <div class="col-lg-3">
                        <div class="s-o-i-w-right">
                          <i class="fa-solid fa-arrow-right"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>  
          </div>
      </div>
    </div>
  </div>

  {/* <!--services section 3 end--> */}


 

</main>

    {/* <!--middle end--> */}
    </div>
  )
}
